// Shared symptom sentinels used by the infection-surveillance pickers
// (CreateInfectionCase, EditInfectionSite, SurveillanceSymptoms) and the ruleset
// editor. Kept in one place so the "Common"/archived handling cannot drift
// between the screens that offer symptoms for selection.

// Legacy symptoms and symptom types carry this class type instead of a real
// infection site. They are kept so historical cases still render, but are never
// offered as a new selection.
export const COMMON_CLASS_TYPE = "Common";

// Suffixes appended to a symptom's display text in the option lists. A symptom
// can be legacy (Common/soft-deleted) or archived, never both in the label.
export const LEGACY_OPTION_SUFFIX = " (OLD)";
export const ARCHIVED_OPTION_SUFFIX = " (ARCHIVED)";
